// extracted by mini-css-extract-plugin
export default {"cell":"PostalCodeFields_cell__PcfNc"};